import {AuthService} from '../services/auth.service';
import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';

@Component({
  templateUrl: './logout-dialog.component.html'
})
export class LogoutDialogComponent implements OnInit {
  constructor(private authService: AuthService,
              private matDialogRef: MatDialogRef<LogoutDialogComponent>) {
  }

  public ngOnInit(): void {
    this.matDialogRef.updateSize('600px');
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public logout(): void {
    this.matDialogRef.close();

    this.authService.logout();
  }
}
